import { APIRequest } from "./apiClient"

export  interface InterfaceData {
    question1: string|null; 
    question2: string|null; 
    question3: string|null; 
    question4: string|null; 
    question5: string|null; 
    question6: string|null; 
    question7: string|null; 
    question8: string|null; 
    question9: string|null; 
    question10: string|null; 
  }
const SurveyService = {
    sendSurvey: async (data: InterfaceData) => {
      const response = await APIRequest({ url: `survey-store`, requestBody: data, requestMethod: 'POST' });
      return response.data;
    }
}
export default SurveyService;